// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"audienceTextMessage_mainContainer__2reBG","userImg":"audienceTextMessage_userImg__2sI6g","messageContainer":"audienceTextMessage_messageContainer__2bxyz"};